// ■コンポーネント説明
// サービス詳細表示用コンポーネント

import React, { useEffect } from 'react';
import SEO from '@/components/seo';
import ServiceRelation from '@/components/Service/ServiceRelation';
import CDNReplace from '@/components/CDNReplace';
import UIBreadcrumb from '@/components/UI/UIBreadcrumb';
import ContactBox from '@/components/Contact/ContactBox';
import * as Util from '@/components/Util';
import hoverCircle from '../Interaction/hoverCircle';

import * as pageHeaderDetail from '@/styles/object/page-header-detail.module.scss';

export interface ServiceDetailProps {
  data: GatsbyTypes.ServicePageQuery;
}

const labelSplit = function f(label: string[]) {
  const result = label[0].split(`/`);
  return result[1];
};

const ServiceDetail: React.FC<ServiceDetailProps> = (props) => {
  const { data } = props;
  let contactData: readonly Pick<
    MicrocmsServiceBodyContact,
    'button' | 'title' | 'id' | 'tayori'
  >[] = [];

  useEffect(() => {
    hoverCircle();
  }, []);

  if (data.microcmsService === null) {
    if (typeof window !== `undefined`) {
      window.location.href = `/404`;
    }
    return null;
  }

  contactData = data.microcmsService.contact;

  return (
    <>
      <SEO
        title={`${data.microcmsService.subTitle !== null
          ? `${data.microcmsService.subTitle} `
          : ``
          }${data.microcmsService.title} | サービス`}
        description={data.microcmsService.description}
        keyword={data.microcmsService.keyword}
      />
      <div className={`page-wrap --detail --${data.microcmsService.category}`}>
        <div className="page-wrap__wave" />
        <div className="page-wrap__bg" />
        <div className="page-contents-box --margin-top">
          <header className={pageHeaderDetail.page_header_detail}>
            {data.microcmsService.label.length > 0 && (
              <p className={pageHeaderDetail.page_header_detail__title_head}>
                {labelSplit(data.microcmsService.label)}
              </p>
            )}
            {data.microcmsService.label.length === 0 && (
              <p className={pageHeaderDetail.page_header_detail__title_head}>
                {Util.formatCategoryName(data.microcmsService.category[0])}
              </p>
            )}
            <h1 className={pageHeaderDetail.page_header_detail__title}>
              {data.microcmsService.subTitle !== null && (
                <small>{data.microcmsService.subTitle}</small>
              )}
              {data.microcmsService.title}
            </h1>
          </header>
          <div className="editor">
            {data.microcmsService.body &&
              data.microcmsService.body.map((body) => {
                let output = ``;
                if (body.rich) {
                  output = body.rich;
                }
                if (body.plain) {
                  output = body.plain;
                }
                if (body.column) {
                  const arr = body.column;
                  arr.forEach((column) => {
                    let columnOutputInner = ``;
                    if (column.rich) {
                      columnOutputInner += column.rich;
                    }
                    if (column.plain) {
                      columnOutputInner += column.plain;
                    }
                    if (column.label) {
                      columnOutputInner += column.label;
                    }

                    output += `<div ${column.class !== null
                      ? `class="${Util.commaShapeBlank(column.class)}"`
                      : ``
                      }>${column.url
                        ? `<a href=${column.url}>${columnOutputInner}</a>`
                        : `${columnOutputInner}`
                      }</div>`;
                  });
                }
                if (body.asset) {
                  const assetArray = body.asset;
                  assetArray.forEach((Item) => {
                    const arr = Item.assetBody;
                    arr.forEach((elem) => {
                      if (elem.rich) {
                        output += elem.rich;
                      }
                      if (elem.plain) {
                        output += elem.plain;
                      }
                    });
                  });
                }
                if (body.contact) {
                  let contactBtn = ``;
                  body.contact.forEach((contactItem) => {
                    contactBtn += `<a href="/contact/${contactItem.id}/" class="button-02 js-hover-circle" data-circle-type="reverse-button" data-circle-inner="arrow-right-orange">${contactItem.button}</a>`;
                  });
                  output += `<div class="btn">${contactBtn}</div>`;
                }
                if (body.file) {
                  output += `<a href="${body.file.url}" target="_blank">${body.fileLabel}</a>`;
                }
                return (
                  <div
                    className={
                      body.class !== null
                        ? `${Util.commaShapeBlank(body.class)}`
                        : ``
                    }
                    id={
                      body.anchorId ? `${body.anchorId.replace(`#`, ``)}` : ``
                    }
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: CDNReplace(output) }}
                  />
                );
              })}
          </div>
        </div>
      </div>
      <ContactBox service={contactData} />
      <ServiceRelation
        currentServiceId={data.microcmsService.serviceId}
        currentTag={data.microcmsService.tag}
      />
      <UIBreadcrumb
        UpperItem={[
          [`Service`, `/service`],
          [
            `${Util.formatCategoryName(data.microcmsService.category[0])}`,
            `/service/${data.microcmsService.category}`,
          ],
        ]}
        CurrentItem={data.microcmsService.title}
      />
    </>
  );
};

export default ServiceDetail;
